<template>
  <footer class="footer">
    <div class="container-fluid">
      <ul class="nav">
        <li class="nav-item">
          <a
            class="nav-link"
            href="https://www.youtube.com/@onebitebitcoin"
            target="_blank"
          >
            한입 비트코인 유튜브</a
          >
        </li>
        <li class="nav-item">
          <a class="nav-link" href="http://BTCMAP.KR" target="_blank">
            비트코인 결제 매장</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="mailto:onebitebitcoin@gmail.com?subject=문의사항&body=안녕하세요, 문의드립니다."
          >
            문의
          </a>
        </li>
      </ul>
      <div class="copyright">© {{ year }} made by 한입 비트코인.</div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
